import { Divider, Stack } from "@mui/material";
import FooterSection from "./FooterSection";
import MenuSection from "./MenuSection";

export default function Sidebar() {
    return (
        <Stack
            sx={{
                width: "224px",
                height: "100%",
                overflow: "hidden",
                gap: "8px",
                bgcolor: "var(--bg-secondary)",
                "& .sidebar-padding": { padding: "8px" },
            }}
        >
            <Stack
                className="section"
                sx={{
                    flex: 1,
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": { display: "none" },
                }}
                style={{ padding: 0 }}
            >
                <MenuSection />
            </Stack>

            <Divider />

            <Stack className="section sidebar-padding">
                <FooterSection />
            </Stack>
        </Stack>
    );
}
